const RESIZE_OBSERVER_WARNINGS = new Set([
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications.",
]);

if (process.env.NODE_ENV === "development") {
  window.addEventListener(
    "error",
    (event) => {
      if (!RESIZE_OBSERVER_WARNINGS.has(event.message)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );
}

import("./bootstrap");
